import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { UserState } from '@coin/shared/auth/feature';
import { MeritBudgetAllocationState } from '../../merit-budget-allocation/store/merit-budget-allocation.state';
import { MeritAllocationGeneralService } from './merit-allocation-general.service';
import { MeritAllocationImpersonatedEmployeeService } from './merit-allocation-impersonated-employee.service';

@Injectable({ providedIn: 'root' })
export class AllocationUserOrgCodeService {
  private readonly meritAllocationGeneralService = inject(MeritAllocationGeneralService);
  private readonly userState = inject(UserState);
  private readonly meritAllocationImpersonatedEmployeeService = inject(MeritAllocationImpersonatedEmployeeService);
  private readonly meritBudgetAllocationState = inject(MeritBudgetAllocationState);

  private userOrgCode: string;

  public getUserOrgCode(): Observable<string> {
    const userId = this.userState.user().id;
    const seasonId = this.meritBudgetAllocationState.season().id;

    if (this.userOrgCode) {
      return of(this.userOrgCode);
    }

    return this.loadAndStoreUserOrgCode(userId, seasonId);
  }

  private loadAndStoreUserOrgCode(userId: string, seasonId: string): Observable<string> {
    const impersonatedEmployeeId = this.meritAllocationImpersonatedEmployeeService.employeeId;
    return this.meritAllocationGeneralService.getEmployeeSnapshotById(seasonId, impersonatedEmployeeId || userId).pipe(
      map(employee => employee?.paOrgCode),
      tap(orgCode => {
        this.userOrgCode = orgCode;
      })
    );
  }
}
